import React from 'react';
import {motion} from 'framer-motion';

const portraitUrl='https://media-manager-c.questera.ai/greta-media/4320f8aaa9ed428bff142ca67321b3bfce2c39771503d4270b0b625b52f5e6960d1f85712829807a2ee1ac58fcf9446b/images/aW1hZ2UvcG5n/9e302fc707c16948e64033af44fa1377.png';

function Hero() {
  return (
    <section className="hero" id="top">
      <motion.div
        className="hero-copy"
        initial={{opacity: 0,y: 24}}
        animate={{opacity: 1,y: 0}}
        transition={{duration: 0.7}}
      >
        <p className="eyebrow">Laurel,Maryland · Social Media Buyer &amp;Builder</p>
        <h1>
          I get paid to make people stop scrolling. Now I&apos;m doing it for{' '}
          <span className="highlight">my own town.</span>
        </h1>
        <p className="hero-subhead">
          By day I run paid social and search for national brands. Off the clock,I&apos;m building Laurel Local Business and a shared postcard project for the town I actually live in.
        </p>
      </motion.div>

      <motion.figure
        className="portrait-frame"
        initial={{opacity: 0,rotate: 0,scale: 0.95}}
        animate={{opacity: 1,rotate: 2.2,scale: 1}}
        transition={{duration: 0.8,delay: 0.15}}
      >
        <img
          src={portraitUrl}
          alt="Perry Dasilva"
          style={{objectPosition: '50% 30%'}}
        />
      </motion.figure>
    </section>
  );
}

export default Hero;